module.exports = __webpack_public_path__ + "img/锁阳.c469749d.jpg";